import React, { Component } from 'react';
import { reduxForm} from 'redux-form';import { connect } from 'react-redux';
import { CommonButton } from '../../../../../components/buttons';
import UploadRawDataForTargets from './uploadRawDataForTargetModal';
import UploadRawDataForBehavior from './uploadRawDataForBehaviorModal';


const validate = (values) => {
    const errors = {};
    
    return errors;
  };

  
class UploadRawData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openTargetModal:false,
            openBehaviorModal:false,
            uploadCSVDocumentObj: null,
        }
    }

   openRawDataTargetModal = () => {
    this.setState({openTargetModal:true})
   }

   CloseRawDataTargetModal = () => {
    this.setState({openTargetModal:false})
   }
   openRawDataBehaviorModal = () => {
    this.setState({openBehaviorModal:true})
   }

   CloseRawDataBehaviorModal = () => {
    this.setState({openBehaviorModal:false})
   }


    render() {
        return (
            <div className="row">
                <div className="panel_title">
                    <em>{this.props.title}</em>
                </div>
                <div className="col-sm-12">
                    <div>
                        <CommonButton className="mt-10" label="Upload Raw Data For Targets" primary={true} onTouchTap={this.openRawDataTargetModal} />
                    </div>
                    <div>
                        {this.state.openTargetModal?
                          <UploadRawDataForTargets
                          documentHandler={this.props.uploadRawDataTarget}
                          dialogTitle={'Upload Raw Data For Targets'}
                          uploadCSVDocumentObj={this.state.uploadCSVDocumentObj}
                          closeDialog = {this.CloseRawDataTargetModal}
                          />:
                          null
                        }
                    </div>
                </div>
                <div className="col-sm-12">
                    <div>
                        <CommonButton className="mt-10" label="Upload Raw Data For Behavior" primary={true} onTouchTap={this.openRawDataBehaviorModal} />
                    </div>
                    <div>
                        {this.state.openBehaviorModal?
                          <UploadRawDataForBehavior
                          documentHandler={this.props.uploadRawDataBehavior}
                          dialogTitle={'Upload Raw Data For Behavior'}
                          uploadCSVDocumentObj={this.state.uploadCSVDocumentObj}
                          closeDialog = {this.CloseRawDataBehaviorModal}
                          />:
                          null
                        }
                    </div>
                </div>
            </div>
        )
    }
}


export default UploadRawData;


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/uploadExcel/uploadRawData/index.js